import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Avatar, Flex, FormControl, FormLabel, HStack, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { CUIAutoComplete } from 'chakra-ui-autocomplete';

var CustomRender = function CustomRender(selected) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDir: "row",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Avatar, {
      mr: 2,
      size: "sm",
      src: selected.avatar_url,
      name: selected.label
    }), /*#__PURE__*/_jsx(Text, {
      color: "black",
      children: selected.label
    })]
  });
};

export var FilterForm = function FilterForm(props) {
  var _useState = useState([]),
      selectedItems = _useState[0],
      setSelectedItems = _useState[1];

  var _useState2 = useState(props.publishers.map(function (p) {
    return _objectSpread({
      label: p.name,
      value: p.name
    }, p);
  })),
      pickerItems = _useState2[0],
      setPickerItems = _useState2[1];

  var _useState3 = useState(''),
      fromYear = _useState3[0],
      setFromYear = _useState3[1];

  var _useState4 = useState(''),
      untilYear = _useState4[0],
      setUntilYear = _useState4[1];

  var handleSelectedItemsChange = function handleSelectedItemsChange(selectedItems) {
    if (selectedItems) {
      setSelectedItems(selectedItems);
    }
  };

  useEffect(function () {
    props.onChange({
      fromYear: fromYear,
      untilYear: untilYear,
      publishers: selectedItems.map(function (v) {
        return v.value;
      })
    });
  }, [selectedItems, fromYear, untilYear]);
  var helperColor = useColorModeValue('gray.600', 'gray.200');
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsx(CUIAutoComplete, {
      disableCreateItem: true,
      hideToggleButton: true,
      label: "Publishers",
      placeholder: "Type a name",
      items: pickerItems,
      selectedItems: selectedItems,
      itemRenderer: CustomRender,
      onSelectedItemsChange: function onSelectedItemsChange(changes) {
        return handleSelectedItemsChange(changes.selectedItems);
      }
    }), selectedItems.length > 1 && /*#__PURE__*/_jsxs(Text, {
      fontSize: "sm",
      color: helperColor,
      children: ["Will search articles that", ' ', selectedItems.length === 2 ? 'both' : 'all', " authors appears in"]
    }), /*#__PURE__*/_jsxs(HStack, {
      children: [/*#__PURE__*/_jsxs(FormControl, {
        id: "fromYear",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "From"
        }), /*#__PURE__*/_jsxs(NumberInput, {
          size: "md",
          value: fromYear,
          min: 1990,
          onChange: setFromYear,
          children: [/*#__PURE__*/_jsx(NumberInputField, {}), /*#__PURE__*/_jsxs(NumberInputStepper, {
            children: [/*#__PURE__*/_jsx(NumberIncrementStepper, {}), /*#__PURE__*/_jsx(NumberDecrementStepper, {})]
          })]
        })]
      }), '-', /*#__PURE__*/_jsxs(FormControl, {
        id: "untilYear",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "Until"
        }), /*#__PURE__*/_jsxs(NumberInput, {
          size: "md",
          value: untilYear,
          onChange: setUntilYear,
          children: [/*#__PURE__*/_jsx(NumberInputField, {}), /*#__PURE__*/_jsxs(NumberInputStepper, {
            children: [/*#__PURE__*/_jsx(NumberIncrementStepper, {}), /*#__PURE__*/_jsx(NumberDecrementStepper, {})]
          })]
        })]
      })]
    })]
  });
};
export default FilterForm;